import { useLanguage } from '@/context/LanguageContext';
import { ChevronDown, Shield } from 'lucide-react';

const HERO_IMG = '/project/render-1.jpg';

export default function HeroSection() {
  const { t } = useLanguage();

  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative h-screen min-h-[700px] flex items-end overflow-hidden" data-testid="hero-section">
      <div className="absolute inset-0">
        <img
          src={HERO_IMG}
          alt="Luxury villa with infinity pool"
          className="w-full h-full object-cover scale-105"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-[#050505]/50 to-transparent" />
        <div className="absolute inset-0 bg-gradient-to-r from-[#050505]/60 to-transparent" />
      </div>

      <div className="relative z-10 px-6 md:px-12 lg:px-24 max-w-[1600px] mx-auto w-full pb-16 md:pb-24">
        <div className="max-w-3xl space-y-6 md:space-y-8">
          <div className="flex items-center gap-3">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 bg-[#C8B598]/10 border border-[#C8B598]/30 backdrop-blur-sm" data-testid="hero-badge">
              <Shield className="w-3.5 h-3.5 text-[#C8B598]" />
              <span className="text-[10px] md:text-xs font-medium uppercase tracking-[0.2em] text-[#C8B598]">
                {t('hero.badge')}
              </span>
            </div>
          </div>

          <p className="text-xs md:text-sm font-medium uppercase tracking-[0.2em] text-[#C8B598]">
            {t('hero.overline')}
          </p>

          <h1 className="font-heading text-4xl sm:text-5xl lg:text-7xl font-light tracking-tighter text-[#F5F5F0] leading-none">
            {t('hero.title')}
          </h1>

          <p className="text-base md:text-lg font-light leading-relaxed text-[#9CA3AF] max-w-xl">
            {t('hero.subtitle')}
          </p>

          <div className="flex flex-col sm:flex-row gap-4 pt-2">
            <button
              onClick={() => scrollTo('contact')}
              className="inline-flex items-center justify-center px-8 py-4 bg-[#C8B598] text-[#050505] font-medium tracking-wide transition-all duration-300 hover:bg-[#E2D1B8] hover:scale-[1.02] text-sm"
              data-testid="hero-cta-button"
            >
              {t('hero.cta')}
            </button>
            <button
              onClick={() => scrollTo('gallery')}
              className="inline-flex items-center justify-center px-8 py-4 bg-transparent border border-[#C8B598]/40 text-[#C8B598] font-medium tracking-wide transition-all duration-300 hover:bg-[#C8B598] hover:text-[#050505] text-sm"
              data-testid="hero-secondary-button"
            >
              {t('hero.ctaSecondary')}
            </button>
          </div>
        </div>

        <button
          onClick={() => scrollTo('about')}
          className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[#9CA3AF] animate-bounce"
          data-testid="scroll-down-button"
          aria-label="Scroll down"
        >
          <ChevronDown className="w-6 h-6" />
        </button>
      </div>
    </section>
  );
}
